import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import scratchCover from '../../../assets/images/ImageScratch.jpeg';
import lottie from "lottie-web";
import confetti from "../../../assets/animation/confetti.json";
import AppContext from 'Contexts/AppContext';


interface PaymentProductSuccessProps {
  paymentSuccessAction: () => void,
  afterPaymentData: any,
  startAgainAction: () => void
  ShareCardPopup: any
  setRewardAmount: any
  setShareCardUrl: any
}

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(255,255,255,0.05);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction:column;
  z-index: 9999;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.10);
  padding: 32px 32px 24px 32px;
  min-width: 340px;
  max-width: 420px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1.5px solid #e6fbe6;
`;

const CheckCircle = styled.div`
  background: #e6fbe6;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  font-size: 2.2rem;
`;

const Heading = styled.h2`
  margin: 0 0 8px 0;
  color: #222;
  font-weight: 700;
  font-size: 1.4rem;
  text-align: center;
`;

const SubText = styled.p`
  margin: 0 0 18px 0;
  color: #222;
  font-size: 1.1rem;
  text-align: center;
`;

const ImageDiv = styled.div`
  margin-bottom: 12px;  
  border-radius: 12px;
  border: 2px solid #FFD700;
  padding: 8px;
  
`;

const ProductImage = styled.img`
  width: 220px;
//   height: 180px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
  
`;


const RewardRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  width: 100%;
  justify-content: center;
`;

const GiftIcon = styled.span`
  font-size: 1.3rem;
  margin-right: 8px;
`;

const RewardText = styled.div`
  color: #222;
  font-size: 1.1rem;
  font-weight: 500;
  span {
    font-weight: 700;
    font-size: 1.2rem;
  }
`;

const AskText = styled.p`
margin-top:10px;
  color:rgb(81, 81, 81);
  font-size: 0.8rem;
  // font-weight: 500;  
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  margin-top: 8px;
`;

const BlueButton = styled.button`
  background: #1976f7;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 12px 18px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  flex: 1;
  justify-content: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(120deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0.15) 100%);
    transform: translateX(-100%) rotate(10deg);
    animation: glossy-shine 1.5s infinite cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
  }

  @keyframes glossy-shine {
    0% {
      transform: translateX(-100%) rotate(10deg);
    }
    60% {
      transform: translateX(120%) rotate(10deg);
    }
    100% {
      transform: translateX(120%) rotate(10deg);
    }
  }
`;

const OutlinedButton = styled.button`
  background: #fff;
  color: #222;
  border: 1.5px solid #e0e0e0;
  border-radius: 10px;
  padding: 12px 18px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  flex: 1;
`;

const CloseButton = styled.button`
  position: absolute;
  width:30px;
  height:30px;
  border-radius: 50px;
  background-color:#fefefe;
  top: 18px;
  right: 18px;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: #888;
  cursor: pointer;
  z-index: 2;
  transition: color 0.2s;
  &:hover {
    color: #1976f7;
  }
`;

const ScratchTitle = styled.h3`
  margin: 0 0 16px 0;
  color:#FFD700;
  font-size: 1.2rem;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.5px;
`;

const PaymentProductSuccess: React.FC<PaymentProductSuccessProps> = ({
  paymentSuccessAction,
  afterPaymentData,
  startAgainAction,
  ShareCardPopup,
  setRewardAmount,
  setShareCardUrl,
}) => {
  // Safely extract product data
  const { buyProduct } = useContext(AppContext);
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const products = afterPaymentData?.result?.data || [];
  const product = products[currentIndex] || {};
  const imageUrl = product?.image_link;
  const productName = product?.productName;
  const productValue = product?.priceUsd;
  const reward = product?.vCoin;
  const shouldShowScratch = buyProduct?.name === "Gold Mystery Box" || buyProduct?.name === "Mystery Box";

  const navigator = useNavigate()
  // const rewardExtra = product.rewardExtra || '40,000 with Social Boost';  
  console.log(products, "product")

  const [showScratch, setShowScratch] = React.useState(shouldShowScratch);
  const canvasRef = React.useRef<HTMLCanvasElement>(null);


  useEffect(() => {
    const encodedName = encodeURIComponent(productName);
    setShareCardUrl(encodedName.replaceAll("%20", "-"))
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const img = new window.Image();
    img.src = scratchCover;
    img.onload = () => {
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    };
  }, [currentIndex]);



  const [scratching, setScratching] = React.useState(false);
  const lastPointer = React.useRef<{ x: number; y: number } | null>(null);

  function getPointerPos(e: any) {
    const canvas = canvasRef.current;
    if (!canvas) return { x: 0, y: 0 };
    const rect = canvas.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return {
      x: clientX - rect.left,
      y: clientY - rect.top
    };
  }

  function handleScratchStart(e: any) {
    setScratching(true);
    const pos = getPointerPos(e);
    lastPointer.current = pos;
    scratch(e);
  }

  function handleScratchMove(e: any) {
    if (!scratching) return;
    scratch(e);
  }

  function handleScratchEnd() {
    setScratching(false);
    lastPointer.current = null;
    checkScratchPercent();
  }

  function scratch(e: any) {
    e.preventDefault();

    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const pos = getPointerPos(e);
    const last = lastPointer.current;

    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.lineWidth = 50; // 👈 reduce line width
    ctx.globalAlpha = 0.9; // 👈 soften the brush a bit

    ctx.beginPath();
    if (last) {
      ctx.moveTo(last.x, last.y);
      ctx.lineTo(pos.x, pos.y);
      ctx.stroke();
    } else {
      ctx.arc(pos.x, pos.y, 15, 0, Math.PI * 2); // smaller soft dot
      ctx.fill();
    }
    ctx.closePath();

    lastPointer.current = pos;
  }



  function checkScratchPercent() {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    let transparent = 0;
    for (let i = 3; i < imageData.data.length; i += 4) {
      if (imageData.data[i] === 0) transparent++;
    }
    const percent = transparent / (canvas.width * canvas.height) * 100;
    if (percent > 50 && shouldShowScratch) {
      setShowScratch(false);
      const container = document.querySelector("#card-animation");
      if (container) {
        container.innerHTML = ""; // Clear previous animation
        lottie.loadAnimation({
          container: container,
          animationData: confetti,
          renderer: "svg",
          loop: false,
          autoplay: true,
        });
      }
    }
  }

  return (
    <Overlay>
      <Card style={{ position: 'relative', overflow: 'hidden' }}>
        {/* Scratch title and canvas */}
        {showScratch && (
          <>
            <canvas
              ref={canvasRef}
              width={420}
              height={300}
              style={{
                position: 'absolute',
                top: 0, // push canvas down to make room for title
                left: 0,
                borderRadius: 20,
                zIndex: 10,
                width: '100%',
                height: '100%',
                cursor: 'pointer',
                pointerEvents: 'auto',
                touchAction: 'none',
              }}
              onMouseDown={handleScratchStart}
              onMouseMove={handleScratchMove}
              onMouseUp={handleScratchEnd}
              onMouseLeave={handleScratchEnd}
              onTouchStart={handleScratchStart}
              onTouchMove={handleScratchMove}
              onTouchEnd={handleScratchEnd}
            />
          </>
        )}

        {/* Lottie confetti layer */}
        <div id="card-animation" style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 12,
        }}></div>
        <>
          <CloseButton
            onClick={() => {
              if (currentIndex < products.length - 1) {
                setCurrentIndex(currentIndex + 1);
                setShowScratch(shouldShowScratch ? true : false); // reset scratch for next card
              } else {
                startAgainAction();
                navigator("/buyget");
              }
            }}
            aria-label="Close"
          >
            &times;
          </CloseButton>
          {/* <CheckCircle>
              <span role="img" aria-label="success">✔️</span>
            </CheckCircle> */}
          {/* <Heading>Payment Successful!</Heading>         */}
          {imageUrl && (
            <ImageDiv>
              <ProductImage src={imageUrl} alt={productName || 'Product'} />
            </ImageDiv>
          )}
          {shouldShowScratch ?
            <SubText>
              You’ve scored the <b>{productName}</b> <br />{productValue?.toLocaleString()}$ value
            </SubText>
            :
            <SubText>
              You have purchased: <b>{productName || 'Product'}</b>
            </SubText>
          }
          <RewardRow>
            <RewardText>
              You Got <b style={{ color: "#FFD700" }}> {reward?.toLocaleString()} Vcoins </b>
            </RewardText>
          </RewardRow>
          <AskText>Want to double your Vcoins? Share now!</AskText>
          <ButtonRow>
            <OutlinedButton onClick={() => {
              navigator("/profile/Purchases");
              paymentSuccessAction();
            }}>
              View purchase
            </OutlinedButton>
            <BlueButton onClick={() => {
              ShareCardPopup();
              setRewardAmount(reward?.toLocaleString());
            }}>
              Share now
            </BlueButton>
          </ButtonRow>
          {/* <AskText>Share now and double your Vcoins</AskText> */}
        </>
      </Card>
    </Overlay>
  );
};

export default PaymentProductSuccess; 